<!--
 * @Author: zhangjiangpo
 * @Date: 2023-10-27 14:44:01
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2023-10-31 15:33:47
 * @Description:
-->
<!--
 * @Author: wangyan1
 * @Description: 查看学员详情
 * @Date: 2022-05-06 15:35
 * @LastEditTime: 2023-10-27 15:08:30
 * @FilePath: /teacher-xkh-web/src/views/groupManage/students/detail.vue
-->
<template>
  <div class="student-detail" v-show="visible">
    <a-drawer
      placement="right"
      :closable="true"
      :visible="visible"
      :after-visible-change="afterVisibleChange"
      destroy-on-close="true"
      @close="close"
      width="900"
      :get-container="getContainer"
    >
      <template slot="title">
        <div class="drawer-header">
          <div class="title-group">
            <div class="title-name">
              {{ record.studentName }} <a-divider type="vertical" />{{ groupInfo.groupName }} （{{ groupInfo.studentNum }}人）
            </div>
            <div class="title-name">
              <a-divider type="vertical" />
              <span class="label">{{ groupInfo.itvCourseName }}</span>
            </div>
          </div>
          <div class="title-phone">
            {{ record.phoneNumber }} <span>   <a-divider type="vertical" />  学生ID: {{ record.userId }}</span>
          </div>
        </div>
      </template>
      <div class="detail-container">
        <template v-if="record.sourceType === 2">
          <InJzxTool
            v-if="visible"
            page-type="1"
            :page-params="{
              studentUserId: record.userId,
              classTypeId: record.classTypeId,
              coursePackageId: record.coursePackageId
            }"
            @event-handle="handleJzxToolEvent"
          />
        </template>
        <template v-else>
          <div class="detail-tabs">
            <a-tabs v-model="activeKey" @change="handleTabChange">
              <a-tab-pane key="studyDetail" tab="学习详情" />
              <a-tab-pane key="studyReport" tab="学习报告" />
            </a-tabs>
          </div>
          <div class="detail-content">
            <div class="tab-content lessons-content">
              <a-table
                :loading="lessonsLoading"
                :columns="columnsLessons"
                :data-source="lessonList"
                :custom-row="customRowFun"
                :row-class-name="rowClassName"
                :pagination="false"
                row-key="id"
              >
                <span slot="lesson" slot-scope="text, item">
                  <template>
                    <div class="lessons-bar">
                      第{{ item.num }}讲
                      <a-tag v-if="activeKey === 'studyDetail' && item.tagName">
                        {{ item.tagName }}
                      </a-tag>
                      <a-tag v-else-if="activeKey === 'studyReport' && item.finishText">
                        {{ item.finishText }}
                      </a-tag>
                    </div>
                    <div class="lessons-title">
                      {{ item.name }}
                    </div>
                  </template>
                </span>
              </a-table>
            </div>
            <div class="tab-content mod-content">
              <div v-show="activeKey === 'studyDetail'" class="stu-detailtabs">
                <div class="tab">
                  <a-menu v-model="activeDetailType" @click="onTabClick" mode="horizontal">
                    <a-menu-item v-for="item in tabs" :key="item.key">
                      {{ item.name }}
                      <a-tooltip v-show="item.isGiveThumbs" placement="top">
                        <template #title>
                          <span>家长点赞</span>
                        </template>
                        <span class="tab-tag">赞</span>
                      </a-tooltip>
                    </a-menu-item>
                  </a-menu>
                </div>
                <div class="stu-detail-list">
                  <Timeline
                    v-if="activeKey === 'studyDetail'"
                    :detail-type="activeDetailType"
                    :timeline-data="timelineData"
                    :show-button="showButton"
                    @handleGoCheck="handleGoCheck"
                  />
                </div>
              </div>
              <div v-show="activeKey === 'studyReport'" class="stu-report">
                <view-report
                  v-if="showReport"
                  :report-params="reportParams"
                />
                <div v-show="!showReport" class="stu-report-nodata">
                  <a-empty />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </a-drawer>
    <ViewReportDrawer :visible.sync="vrdVisible" :page-params="vrdReportParams" />
  </div>
</template>
<script>
import InJzxTool from '@/components/InJzxTool/index.vue'
import Timeline from '@/components/timeline.vue'
import ViewReport from '../components/viewReport.vue'
import ViewReportDrawer from './viewReportDrawer.vue'
import groupStuLogger from '@/utils/logger/groupStudent.js'
import { EVENT } from '@/utils/Postmate'
// 用table来设置讲次列表数据
const columnsLessons = [
  {
    title: '讲次',
    scopedSlots: { customRender: 'lesson' }
  }
]
const detailKeys = {
  exerciseList: 2,
  noteList: 3,
  accumulateList: 4,
  trainingList: 5
}
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    // 学生信息
    record: {
      type: Object,
      default: () => {}
    },
    // 小组信息
    groupInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Timeline,
    ViewReport,
    InJzxTool,
    ViewReportDrawer
  },
  computed: {
    // pageParams: () => ({
    //   studentUserId: record.userId,
    //   coursePackageId: record.coursePackageId
    // })
    // pageParams () {
    //   console.log('pageParams', this)
    //   return {}
    //   // return {
    //   //   studentUserId: record.userId,
    //   //   coursePackageId: record.coursePackageId
    //   // }
    // }
  },
  data() {
    return {
      tabs: [],
      detailKeys,
      columnsLessons,
      lessonsLoading: false,
      showButton: { checkButton: false, commentButton: true },
      activeKey: 'studyDetail', // tab焦点
      lessonList: [], // 讲次列表
      // activeLesson: '', // 选中的讲次
      timelineData: [], // 学员详情讲次提交数据
      reportUrl: '', // 学习报告地址
      showReport: false,
      activeDetailType: 'exerciseList', // 学生详情默认课本历练
      activeLessonId: '', // 选中的讲次ID
      activeLesson: {}, // 选中的讲次
      // 家长是否点赞
      isGiveThumbs: {
        exerciseList: 0,
        noteList: 0,
        accumulateList: 0,
        trainingList: 0
      },
      reportParams: {},
      pageParams: {},
      vrdVisible: false, // 精准学学习报告抽屉
      vrdReportParams: {} // 精准学学习报告参数
    }
  },
  // watch: {
  //   activeLesson: {
  //     handler() {
  //       this.getData()
  //     },
  //     deep: true
  //   }
  // },
  created() {
    // this.getStudentLesssonList()
  },
  methods: {
    // 获取tabs，讲次环节 tab/点赞信息
    getGiveThumb(params) {
      const tabsKeys = {
        2: 'exerciseList',
        3: 'noteList',
        4: 'accumulateList',
        5: 'trainingList'
      }
      this.$service.correction.giveThumb(params).then(res => {
        this.tabs = res.map(tab => ({
          key: tabsKeys[tab.scenePhaseId],
          name: tab.scenePhaseName,
          type: tab.scenePhaseId,
          isGiveThumbs: tab.isGiveThumbs
        }))
      })
    },
    /**
     * 讲次点击查询数据
     */
    customRowFun(actRecord) {
      return {
        on: {
          click: evt => {
            this.activeLessonId = actRecord.lessonId
            this.activeLesson = actRecord
            // 讲次切换，默认回到第一个tab
            this.activeDetailType = 'exerciseList'
            for (const k in this.isGiveThumbs) {
              this.isGiveThumbs[k] = 0
            }
            this.renderPageRight()
          }
        }
      }
    },
    /**
     * 选中项的样式
     */
    rowClassName(record, index) {
      const { lessonId } = record
      return lessonId === this.activeLessonId ? 'row-select' : ''
    },
    // 学生详情-学习详情tab控制
    onTabClick(evt) {
      this.activeDetailType = evt.key
      console.log('学生详情-学习详情tab控', evt, this.activeDetailType)
      this.renderPageRight()
    },
    // handleGoCheck() {},
    /**
     * 切换页tab事件：学习报告、学习详情
     */
    handleTabChange(key) {
      this.activeKey = key
      if (key === 'studyReport') {
        groupStuLogger.reportLogger({
          groupId: this.groupInfo.id,
          courseId: this.record.classTypeId,
          studentUserId: this.record.userId
        })
      }
      this.renderPageRight()
    },
    // 渲染详情页右侧数据
    renderPageRight() {
      if (this.lessonList.length === 0) {
        return false
      }
      console.log('this.activeKey', this.activeKey)
      if (this.activeKey === 'studyDetail') {
        this.getStudyDetailData()
      } else if (this.activeKey === 'studyReport') {
        this.getStudyReport()
      }
    },
    // 查询学生讲次的学习详情数据
    getStudyDetailData() {
      this.getGiveThumb({
        userId: this.record.userId,
        classTypeId: this.record.classTypeId,
        lessonId: this.activeLessonId
      })
      console.log('查询学生讲次的学习详情数据', this.activeDetailType)
      this.timelineData = []
      this.$service.groupManage.getStudentPathlog({
        classTypeId: this.record.classTypeId,
        lessonId: this.activeLessonId,
        linkType: this.detailKeys[this.activeDetailType],
        userId: this.record.userId,
        pageSize: 100,
        pageNum: 1,
        // 1：学生详情 列表  2：上课与批改 页面
        type: 1
      }).then(res => {
        if (res && res.pathLogList) {
          this.timelineData = res.pathLogList.list || []
        }
        this.isGiveThumbs[this.activeDetailType] = !res.isGiveThumbs ? 0 : res.isGiveThumbs
      })
    },
    // 展示学习报告
    getStudyReport() {
      this.showReport = false
      const { userId, classTypeId } = this.record
      const { lessonId, sign, finish } = this.activeLesson
      this.reportParams = {
        userId,
        classTypeId,
        lessonId,
        checkSign: sign,
        outputSource: 3
      }
      this.showReport = finish
    },
    // 替换指定传入参数的值
    replaceParamVal (oUrl, paramName, replaceWith) {
      const re = new RegExp('(' + paramName + '=)([^&]*)', 'gi')
      const nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
      return nUrl
    },
    getContainer() {
      return document.querySelector('.student-detail')
    },
    /**
     * 关闭学员详情
     * */
    close() {
      this.$emit('update:visible', false)
    },
    // 学员详情讲次列表
    getStudentLesssonList(stuRecord) {
      console.log('getStudentLesssonList', 11111, stuRecord)
      const params = {
        classTypeId: stuRecord.classTypeId,
        studentId: stuRecord.id,
        userId: stuRecord.userId
      }
      console.log('getStudentLesssonList', params)
      this.$service.groupManage.getStudentLessons(params).then(res => {
        if (res) {
          const list = res.filter(item => {
            item = {
              ...item,
              tagName: this.getTagName(item.tag),
              finishText: item.finish ? '已完成' : ''
            }
            return item.lockStatus === 2
          })
          if (list.length > 0) {
            console.log('list', list)
            this.lessonList = list
            this.activeLesson = { ...this.lessonList[0] }
            this.activeLessonId = this.activeLesson.lessonId
            this.renderPageRight()
          }
        }
      })
    },
    getTagName(key) {
      let tagName = ''
      switch (key) {
        case 2: tagName = '期末'
          break
        // 3习题讲次 4外教讲次，统一显示期中
        case 1:
        case 3:
        case 4: tagName = '期中'
          break
        default: tagName = ''
      }
      return tagName
    },
    getLessonState(item) {
      return (this.activeKey === 'studyDetail' && item.tagName.length === 0) ||
      (this.activeKey === 'studyReport' && !item.finish)
    },
    handleJzxToolEvent({ type, msg }) {
      if (type === EVENT.OPEN_PAGE) {
        if (msg.scene === 101) {
          this.vrdVisible = true
          this.vrdReportParams = {
            studentUserId: this.record.userId,
            classTypeId: this.record.classTypeId,
            coursePackageId: this.record.coursePackageId,
            ...msg.params
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/static/css/base.less';
.student-detail{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  height: 100%;
  .qrcode{
    width: 224px;
    height: 246px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 12px 16px;
    position: absolute;
    bottom: 28px;
    right: 891px;
    z-index: 1001;

    opacity: 0;
    animation: cssAnimation 0s 0.25s forwards;

    .arrow{
      display: inline-block;
      position: absolute;
      right: -3px;
      bottom: 6px;
      width: 20px;
      height: 32px;
      background: #FFF;
      transform: rotate(45deg);
      border-radius: 2px;
    }

    .qrcode-body{
      background: @gray-10;
      text-align: center;
      border-radius: 4px;
      height: 100%;
      width: 100%;
      z-index: 2;
      position: relative;
    }

    img{
      width: 200px;
      height: 200px;
      margin-left: -3px;
    }
    .qrcode-text{
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: @gray-3;
    }
  }
}
.ant-drawer{
  :deep(.ant-drawer-content) {
    overflow: unset;
  }
  :deep(.ant-drawer-body) {
    padding: 0;
  }

  .drawer-header{
    font-size: 16px;
    color: @gray-2;
    .title-group {
      display: flex;
    }
    .title-info{
      font-size: 14px;
      color: @gray-3;
      font-weight: 400;

      .ant-divider{
        margin: 0 16px;
      }
    }
  }

  .detail-container{
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .detail-title {
      border-bottom: 1px solid #e8e8e8;
    }
    .detail-tabs {
      padding-top: 24px;

      :deep(.ant-tabs) {
        border-bottom: 1px solid #EBEDF0;
        padding-left: 12px;
        .ant-tabs-tab {
          position: relative;
        }
      }
    }
    .detail-content {
      height: calc(100% - 100px);
      display: flex;
      flex-direction: row;

      .ant-menu-horizontal {
        border-bottom: 0 none;
        .ant-menu-submenu{
          width: 94px;
        }
        .ant-menu-item {
          position: relative;
        }
        .tab-tag {
          position: absolute;
          right: 4px;
          top: 10px;
          line-height: 16px;
          color: #cf1322;
          border-color: #cf1322;
          background-color: #ffe7e8;
        }
      }
      .lessons-content,
      .mod-content {
        height: 100%;
      }
      .lessons-content {
        padding-top: 15px;
        width: 220px;
        border-right: 1px solid #e8e8e8;
        overflow: scroll;
        .ant-table-wrapper {
          :deep(.ant-table .ant-table-thead > tr > th) {
            background: none;
          }
          :deep(.row-select) {
            color: #3262FD;
          }
        }
      }
      .mod-content {
        flex: 1;
        overflow: auto;
        .stu-report-nodata {
          width: 100%;
          height: 100%;
        }
        .stu-detail-list {
          padding-top: 30px;
        }
        .stu-report {
          width: 100%;
          height: 100%;
        }
      }
      .lessons-item {
        padding: 10px 0;
        border-bottom: 1px solid #e8e8e8;
        &.lessons-default{
          cursor: pointer;
          &:hover {
            color: #3262fd;
          }
        }
        &.lessons-unable {
          color: #a0a0a0;
          cursor: default;
        }
      }
      .stu-detailtabs {
        // width: 382px;
      }
    }
  }
  .tab-content {
    padding: 0 24px;
  }
  &.group-drawer{
    .detail-container{
      .report-iframe{
        width:776px;
      }
    }
  }
}
@keyframes cssAnimation {
    to {
     opacity: 1;
    }
}
</style>